import styled from "styled-components";

import { BaseCell, TruncatedTextCell } from "@similarweb/pro-logic-components";

/*
 * After virtualization, table cells switched from <td> (block-level by default) to <div> with display: flex.
 * BaseCell renders as a <span> (inline), which doesn't establish a definite width in
 * a flex context — so children with width: 100% or text-overflow: ellipsis have nothing to resolve against.
 * Adding StyledBlockBaseCell & StyledTruncatedTextCell to fix this.
 * */

export const StyledBlockBaseCell = styled(BaseCell)`
    display: block;
    overflow: hidden;
`;

export const StyledTruncatedTextCell = styled(TruncatedTextCell)`
    display: block;
    overflow: hidden;
`;
